// Define breakpoints
const breakpoints = {
  values: {
    xs: 0,
    sm: 600,
    md: 992,
    lg: 1280,
    xl: 1640,
  },
};

// Export breakpoints
export default breakpoints;
